<template>
  <div>
    <span
      v-if="textForDisableAdmin"
      class="text-disabled"
    >{{ textForDisableAdmin }}
    </span>
    <div>
      <el-select
        :value="adminId"
        :disabled="disabled"
        :placeholder="placeholderRow"
        class="admin-by-row-selector"
        filterable
        clearable
        @input="handleChangeAdmin"
      >
        <el-option
          v-for="item in admins"
          :key="item.adminId"
          :label="item.name"
          :value="item.adminId"
        >
          <div class="admin-option">
            <div class="name">{{ item.name }}</div>
          </div>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import axios from "axios";
import { existValueAndEmptyString } from "@/lib/util";
import { getCookie, Auth } from "@/lib/cookie";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    value: { type: [Number, String, Object], default: null },
    disabled: { type: Boolean, default: false },
    role: { type: String, default: null },
    placeholder: { type: String, default: null },
    textForDisableAdmin: { type: String, default: null }
  },
  data() {
    return {
      admins: []
    };
  },
  computed: {
    adminId() {
      if (!this.value) {
        return null;
      }

      return this.value.adminId
        ? +this.value.adminId
        : +this.value;
    },
    placeholderRow() {
      if (this.placeholder && this.role) return `${this.placeholder} ${this.role}`;
      if (this.placeholder) return this.placeholder;

      return this.role ? this.role : "All";
    }
  },
  created() {
    this.setupAdmins();
  },
  methods: {
    async setupAdmins() {
      try {
        const adminsByRole = await this.fetchAdmins();

        if (!adminsByRole) return;

        this.admins = adminsByRole.map((admin) => ({
          adminId: admin.admin_id,
          name: `${admin.first_name} ${admin.last_name}`,
          roleId: admin.role_id
        }));
      } catch {
        this.admins = [];
      }
    },
    async fetchAdmins() {
      const role = this.role || "Admin";

      const result = await axios.get(`${process.env.HOST}/admin/staffs/${role}/roles`, {
        headers: {
          Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
        }
      });

      return result.data;
    },
    handleChangeAdmin(adminId) {
      if (!existValueAndEmptyString(adminId)) {
        this.$emit("input", null);
        return;
      }

      const matched = this.admins.find(a => a.adminId === adminId);
      this.$emit("input", matched ? matched.adminId : null);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.admin-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.admin-by-row-selector {
  width: 300px;
}

.text-disabled {
  font-size: 12px;
  color: gray;
}
</style>
